import { storeOutboundEventBus } from "src/shared/data-loading/outbound/bus/storeOutboundEventBus";
export function campaignHasBeenUpdated(campaignId) {
    storeOutboundEventBus.emit("campaign_has_been_updated", { campaignId });
}
